import { SelectionModel } from '@angular/cdk/collections';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';
import { BcModelDTO } from 'src/app/shared/dtos/bcModelDTO';
import { StateService } from 'src/app/shared/services/state.service';
import { SocieteModel } from '../../../shared/models/simple-types/societe.model';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef, Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BcComponentsService, DetailBcinfos } from '../bc-components.service';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { Title } from '@angular/platform-browser';
import { InfoLettrageComponent } from '../modals/info-lettrage/info-lettrage.component';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { LivraisonBcModel } from 'src/app/shared/models/societe-linked/bc/livraison-bc.model';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { AddCommentModalComponent } from 'src/app/shared/components/modals/add-comment/add-comment-modal.component';
import { ModalCycleValidationComponent } from '../modals/modal-cycle-validation/modal-cycle-validation.component';
import { ModalFormulaireEmailComponent } from '../modals/modal-formulaire-email/modal-formulaire-email.component';
import { filter, first } from 'rxjs/operators';
import { SessionService } from 'src/app/shared/services/session.service';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

@Component({
  selector: 'app-edit-bc',
  templateUrl: './edit-bc.component.html',
  styleUrls: ['./edit-bc.component.scss']
})
export class EditBcComponent implements OnInit, OnDestroy  {

  bcForm: UntypedFormGroup;
  bc: BcModel = new BcModel();
  bcDTO: BcModelDTO = new BcModelDTO();
  bcList: BcModel[];
  user: string;
  society: SocieteModel;
  observableBc = new BehaviorSubject<BcModel>(null);
  listOfBc: Observable<BcModel>;
  detailBcInfos: DetailBcinfos;
  bcRows: UntypedFormArray = this.fb.array([]);
  selected: SelectionModel<AbstractControl> = new SelectionModel<AbstractControl>();
  bcLineHTs = 0;
  bcLineTVAs = 0;
  bcLineTTCs = 0;

  definitionTypeBC = DefinitionTypeBC; //pour son html

  constructor(
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private router: Router,
    private sessionService: SessionService,
    private title: Title,
    private bcService: BcService,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private state: StateService,
    private toastr: ToastrService,
    private bcComponentsService: BcComponentsService,
    private societeService: SocieteService,) {

    this.state.society.subscribe(result => {
      this.society = result;

    });
    this.state.user.subscribe(result => {
      this.user = result;
    });

    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.bcService.bcSubscriber.subscribe((bc: BcModel) => {
          if (bc !== null) {
            this.bc = Object.assign({}, bc);
          } else {
            this.toastrService.error('Erreur lors de la récupération du bon de commande.', 'Erreur');
            this.router.navigate(['/']);
          }
        });
      } else {
        this.bcService.get(params.id).subscribe((bc: BcModel) => {
          if (bc) {
            this.detailBcInfos = new DetailBcinfos();
            this.bc = bc;
            this.title.setTitle('SACHA - Livrer BC ' + this.bc.code);

            this.observableBc.next(this.bc);
            let i = 0;
            for (const line of this.bc.bcLines) {
              if (line.qteLivre + line.qteAnnule >= line.qte) {
                i++;
              }
              if ((line.qte > line.qteAnnule + line.qteLivre) && !line.bAnnule) {
                const liv = new LivraisonBcModel();
                liv.dLivraison = new Date(Date.now());
                liv.qteLitige = 0;
                liv.qteLivre = 0;
                line.livraisonsBc.push(liv);
              }
            }
            const cloneBc = Object.assign({}, this.bc);
            this.bcForm = this.bcComponentsService.getEditLinesBCFormGroup(cloneBc);
            if (this.bcForm) {
              this.bcLineTVAs = this.bcForm.get('tva').value;
              this.bcLineTTCs = this.bcForm.get('ttc').value;
              this.bcLineHTs = this.bcForm.get('ht').value;
            }
          }
          this.societeService.get(this.bc.idSociete).subscribe((res) => this.bc.societe = res);
        }, (error) => {
          toastrService.error('Le bon de commande n\'existe pas');
          this.router.navigate(['/not-found']);
        });
      }
    });
  }

  ngOnInit(): void {
    this.verifyBcStatusToRedirect();
  }
  ngOnDestroy(): void {
    this.bcComponentsService.purgeDetailBcInfo();
  }

  verifyBcStatusToRedirect(): void {
    if (this.observableBc) {
      this.observableBc.subscribe((bc: BcModel) => {
        if (bc) {
          if (bc.status !== "Validé") {
            this.toastr.warning('Ce bon de commande est n\'est pas encore validé.', 'Erreur');
            this.router.navigate(['/']);
          }
        }
      });
    }
  }

  close(): void {
    this.router.navigate(['/list-bc/']);
  }

  changeAnnule(selected: SelectionModel<AbstractControl>): void {
    this.selected = selected;
  }

  deliver(comment: string, thenClotureBCE = false): void {
    if (this.bcForm.valid) {
      function filterLine(line: BcLineModel): LivraisonBcModel[] {
        return line.livraisonsBc.filter(
          liv => (liv.qteLivre !== 0 || (liv.qteLivre === 0 && line.qteAnnule !== 0 ))
          && liv.qteLivre !== undefined && liv.qteLivre !== null && liv.dLivraison !== null
        );
      }
      const array = this.bcForm.get('bcLines') as UntypedFormArray;
      this.bc.bcLines = array.getRawValue();
      if (this.selected) {
        this.selected.selected.forEach(row => {
          const line = this.bc.bcLines.find(bcline => bcline.id === row.get('id').value);
          if (line) {
            line.bAnnule = true;
            line.dAnnule = new Date();
            line.qteAnnule = (line.qteLivre - line.qteDprovis);
            line.qteRestant = line.qteRestant - line.qteAnnule;
            line.livraisonsBc = filterLine(line);
          }
        });
      }
      this.bc.bcLines.forEach(line => {
        line.livraisonsBc = filterLine(line);
      });
      this.bc.mention = this.bcForm.get('mention').value;
      this.bc.dLivraison = this.bcForm.get('dLivraison').value;
      this.bc.dRegl = this.bcForm.get('dRegl').value;
      this.bc.refFourn = this.bcForm.get('refFourn').value;
      this.bc.commentaires = this.bcForm.get('commentaires').value;
      const dialogRef = this.dialog.open(SpinnerModalComponent);
      if (this.bc.type === this.definitionTypeBC.BCEnveloppe && !thenClotureBCE) {
        this.bcComponentsService.livLinesEnv(this.bc, comment).subscribe((res) => {
          dialogRef.close();
          if (res) {
            this.toastr.success('Enregistrement réussi');
            this.router.navigate(['/edit-bc/' + this.bc.id]);
            if (res.bcLines) {
              for (var line of res.bcLines) {
                let total = 0;
                if (!line.livraisonsBc || line.livraisonsBc.length == 0) {
                  const liv = new LivraisonBcModel();
                  liv.dLivraison = new Date(Date.now());
                  liv.qteLivre = 0;
                  liv.qteLitige = 0;
                  line.livraisonsBc = [];
                  line.livraisonsBc.push(liv);
                } else {
                  line.livraisonsBc.forEach(liv => total += liv.qteLivre);
                  if (((line.qteLivre + line.qteAnnule < line.qte) && !line.bAnnule) ) {
                    const liv = new LivraisonBcModel();
                    liv.dLivraison = new Date(Date.now());
                    liv.qteLivre = 0;
                    liv.qteLitige = 0;
                    line.livraisonsBc.push(liv);
                  }
                } 
              }
            }
            this.bcForm = this.bcComponentsService.getEditBcFormGroup(res);
          }
        }, (error) => {
          dialogRef.close();
          this.toastr.error(error);
        });
      } else if (this.bc.type === this.definitionTypeBC.BCEnveloppe && thenClotureBCE) { 
        this.bcComponentsService.clotureBCE(this.bc, comment).subscribe((res) => {
          dialogRef.close();
          if (res) {
            this.toastr.success('Enregistrement réussi');
            this.router.navigate(['/read-bc/' + this.bc.id]);
            if (res.bcLines) {
              for (var line of res.bcLines) {
                let total = 0;
                if (!line.livraisonsBc || line.livraisonsBc.length == 0) {
                  const liv = new LivraisonBcModel();
                  liv.dLivraison = new Date(Date.now());
                  liv.qteLivre = 0;
                  liv.qteLitige = 0;
                  line.livraisonsBc = [];
                  line.livraisonsBc.push(liv);
                } else {
                  line.livraisonsBc.forEach(liv => total += liv.qteLivre);
                  if (((line.qteLivre + line.qteAnnule < line.qte) && !line.bAnnule) ) {
                    const liv = new LivraisonBcModel();
                    liv.dLivraison = new Date(Date.now());
                    liv.qteLivre = 0;
                    liv.qteLitige = 0;
                    line.livraisonsBc.push(liv);
                  }
                } 
              }
            }
            this.bcForm = this.bcComponentsService.getEditBcFormGroup(res);
          }
        }, (error) => {
          dialogRef.close();
          this.toastr.error(error);
        });
      } else {
        this.bcComponentsService.updateBc(this.bc, comment).subscribe((res) => {
          if (res) {
            dialogRef.close();
            this.toastr.success('Enregistrement réussi');
            this.router.navigate(['/edit-bc/' + this.bc.id]);
  
            for (const line of res.bcLines) {
              let total = 0;
              line.livraisonsBc.forEach(liv => total += liv.qteLivre);
              if (((line.qteLivre + line.qteAnnule < line.qte) && !line.bAnnule) ) {
                const liv = new LivraisonBcModel();
                liv.dLivraison = new Date(Date.now());
                liv.qteLivre = 0;
                liv.qteLitige = 0;
                line.livraisonsBc.push(liv);
              }
            }
            this.bcForm = this.bcComponentsService.getEditBcFormGroup(res);
          }
        }, (error) => dialogRef.close());
      }
    } else {
      this.bcForm.markAllAsTouched();

      // TODO ajout de gestions d'erreur
      const formArray: UntypedFormArray = this.bcForm.get('bcLines') as UntypedFormArray;
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < formArray.controls.length; i++) {
        const livraison: UntypedFormArray = formArray.controls[i].get('livraisonsBc') as UntypedFormArray;
        for (const ligneLivr of livraison.controls) {
          for (const objLivr in (ligneLivr as UntypedFormGroup).controls) {
            if ((ligneLivr as UntypedFormGroup).controls[objLivr].errors) {
                this.toastr.warning('le champ : ' + objLivr + ' est en erreur');
            }
          }
        }
      }
    }
  }

  deliverAll(): void {
    const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
      data: {
        type: 'livrer',
        title: 'Livrer toutes les lignes du bc',
        message: 'Pour une livraison partielle, saisissez la quantité Livrée et cliquer sur "Livrer"',
        color: 'primary',
        disabled: true
      }
    });
    dialogConfirmation.afterClosed().subscribe((date) => {
      if (date) {
        const array = this.bcForm.get('bcLines') as UntypedFormArray;
        this.bc.bcLines = array.getRawValue();
        for (const line of this.bc.bcLines) {
          if (!line.bAnnule && line.fLivre !== 2 && (line.qte !== line.qteAnnule + line.qteLivre)) {

            let resteALivrer = line.qte;
            line.livraisonsBc.forEach(
              liv => { if (liv.id !== undefined) { resteALivrer -= liv.qteLivre; } }
            );

            const lastLiv = line.livraisonsBc.find(liv => liv.id === undefined);
            lastLiv.qteLivre = resteALivrer;
            lastLiv.dLivraison = date;

            line.qteLivre = line.qte;
          }
        }
        this.bc.mention = this.bcForm.get('mention').value;
        this.bc.dLivraison = this.bcForm.get('dLivraison').value;
        this.bc.dRegl = this.bcForm.get('dRegl').value;
        this.bc.refFourn = this.bcForm.get('refFourn').value;
        this.bc.commentaires = this.bcForm.get('commentaires').value;
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.bcComponentsService.updateBc(this.bc, '').subscribe((res) => {
          if (res) {
            dialogRef.close();
            this.toastr.success('Livraison réussie');
            this.router.navigate(['/edit-bc/' + this.bc.id]);
            for (const line of res.bcLines) {
              let total = 0;
              for (const liv of line.livraisonsBc) {
                total += liv.qteLivre;
              }
              if (total < line.qte && !line.bAnnule) {
                const liv = new LivraisonBcModel();
                liv.dLivraison = new Date(Date.now());
                line.livraisonsBc.push(liv);
              }
            }
            this.bcForm = this.bcComponentsService.getEditBcFormGroup(res);
          }
        }, (error) => dialogRef.close());
      }
    });
  }

  lettrageBpInfo(): void {
    const dialogConfirmation = this.dialog.open(InfoLettrageComponent, {
      data: {
        message: 'Info Lettrage',
        form: this.bcForm
      }
    });
    dialogConfirmation.afterClosed().subscribe(res => {
    });
  }


  litigerAll() {
    const dialogRef = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Commentaire du litige',
        color: 'primary',
        icon_color: 'accent',
        required: true
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res !== '' && res) {
        const array = this.bcForm.get('bcLines') as UntypedFormArray;
        const bclignes: BcLineModel[] = array.getRawValue();
        for(var i = 0; i < bclignes.length; i++) {
          if(!bclignes[i].bAnnule && bclignes[i].livraisonsBc) {
            for(var p = 0; p < bclignes[i].livraisonsBc.length; p++) {
              if(bclignes[i].livraisonsBc[p].id && bclignes[i].livraisonsBc[p].qteLivre > 0) {
                bclignes[i].livraisonsBc[p].qteLitige = bclignes[i].livraisonsBc[p].qteLivre;
              }
            }
          }
        }
        this.bc.bcLines = bclignes;
        this.bcForm = this.bcComponentsService.getEditBcFormGroup(this.bc);
        this.deliver(res);
      }else if (res === '') {
        this.toastr.error('Commentaire obligatoire');
      }
    });
  }

  litiger(thenClotureBCE = false): void {
    const array = this.bcForm.get('bcLines') as UntypedFormArray;
    const bclignes: BcLineModel[] = array.getRawValue();
    let change = false;
    for (let i = 0; i < bclignes.length; i++) {
      if (!bclignes[i].bAnnule && bclignes[i].livraisonsBc) {
        for (let p = 0; p < bclignes[i].livraisonsBc.length; p++) {
          if (((i >= this.bc.bcLines.length || p >= this.bc.bcLines[i].livraisonsBc.length) && bclignes[i].livraisonsBc[p].qteLitige > 0) 
            || (this.bc.bcLines[i]?.livraisonsBc[p] && 
             (bclignes[i].livraisonsBc[p].qteLitige !== this.bc.bcLines[i].livraisonsBc[p].qteLitige))) {
            change = true;
            break;
          }
        }
      }
    }
    if (change) {
      const dialogRef = this.dialog.open(AddCommentModalComponent, {
        data: {
          title: 'Commentaire du litige',
          color: 'primary',
          icon_color: 'accent',
          required: true
        }
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res !== '' && res) {
          this.deliver(res);
        }else if (res === '') {
          this.toastr.error('Commentaire obligatoire');
        }
      });
    } else {
      this.deliver('', thenClotureBCE);
    }
  }

  openCycleValidation() {
    const dialog = this.dialog.open(ModalCycleValidationComponent, {
      data: {
        idBc: this.bc.id,
        idSociete: this.bc.idSociete,
        codeCa1: this.bcForm.get('codeCa1').value
      }
    });
  }

  calculateHorsTaxesLivre(object: any): void {
    if (this.getHtAMount(object) !== undefined) {
      this.bcLineHTs = this.getHtAMount(object);
    }
  }

 
  getHtAMount(object: any): number {
    // tslint:disable-next-line
    let amountsHt = [];
    let amountHtTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountHtValue = 0;
      if (object[obj].amount !== undefined) {
        amountHtValue = amountHtValue + object[obj].amount;
        amountsHt.push(amountHtValue);
        if (obj === object.length - 1) {
          for (const amount of amountsHt) {
            amountHtTotal += amount;
          }
          return amountHtTotal;
        }
      }
    }
  }

  sendEmail() {

    this.sessionService.addScope("https://www.googleapis.com/auth/gmail.compose https://www.googleapis.com/auth/gmail.settings.basic https://www.googleapis.com/auth/gmail.send");
    this.sessionService.userResponseSubject.pipe(filter(user => {
      return this.sessionService.containsAskedScope();
    }), first()).subscribe((user) => {
      const dialogConfirmation = this.dialog.open(ModalFormulaireEmailComponent, {
        disableClose: true,
        autoFocus: false,
        width: '70%',
        maxHeight: '99vh',
        data: {
          bcForm: this.bcForm,  
        }
      });
      dialogConfirmation.afterClosed().subscribe(res => {
      });
    });
  }

}
